import React, { useState, useEffect, useRef } from "react";
import { Calendar, MapPin, Users, Search, Hotel } from "lucide-react";
import { DateRange } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import RoomSelector from "../components/RoomSelector";
import Footer from "../components/Footer";
import { fr } from 'date-fns/locale';


export default function HomePage({ onSearch, cities: apiCities = [], brand   }) {

    const STATIC_CITIES = [
  { Id: "10", Name: "Hammamet" },
  { Id: "11", Name: "Nabeul" },
  { Id: "12", Name: "Kelibia" },
  { Id: "13", Name: "Korba" },
  { Id: "14", Name: "Korbous" },
  { Id: "17", Name: "Kairouan" },
  { Id: "18", Name: "Djerba" },
  { Id: "19", Name: "Zarzis" },
  { Id: "20", Name: "Douz" },
  { Id: "22", Name: "Kebili" },
  { Id: "23", Name: "Ksar Ghilane" },
  { Id: "31", Name: "Ain Drahem" },
  { Id: "32", Name: "Tunis" },
  { Id: "33", Name: "Tabarka" },
  { Id: "34", Name: "Sousse" },
  { Id: "35", Name: "Mahdia" },
  { Id: "37", Name: "Monastir" },
  { Id: "39", Name: "Sfax" },
  { Id: "47", Name: "Tozeur" },
  { Id: "48", Name: "Bizerte" },
  { Id: "49", Name: "Le Kef" },
  { Id: "54", Name: "Gafsa" },
  { Id: "55", Name: "Gabes" },
  { Id: "59", Name: "Zaghouan" },
  { Id: "70", Name: "Tataouine" },
  { Id: "71", Name: "Téboursouk" },
  { Id: "72", Name: "Sbeitla" },
  { Id: "73", Name: "Matmata" },
  { Id: "74", Name: "Sidi Bouzid" },
  { Id: "75", Name: "Nefta" },
  { Id: "76", Name: "Mednenine" },
  { Id: "6482", Name: "El Jem" },
  { Id: "6483", Name: "Kerkennah" },
  { Id: "6484", Name: "Nefza" },
  { Id: "6485", Name: "Gammarth" },
  { Id: "6487", Name: "Béja" },
];

  const [cities, setCities] = useState(STATIC_CITIES);
  const [destination, setDestination] = useState("");
  const [dateRange, setDateRange] = useState([
    {
      startDate: new Date(),
      endDate: new Date(new Date().setDate(new Date().getDate() + 3)),
      key: "selection",
    },
  ]);
  const [showCalendar, setShowCalendar] = useState(false);
  const [rooms, setRooms] = useState([{ adults: 2, children: [] }]);
  const calendarRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (calendarRef.current && !calendarRef.current.contains(event.target)) {
        setShowCalendar(false);
      }
    };

    if (showCalendar) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showCalendar]);

  const handleSearch = () => {
    if (!destination) {
      alert("Veuillez sélectionner une destination");
      return;
    }
    onSearch({
      destination,
      checkIn: dateRange[0].startDate,
      checkOut: dateRange[0].endDate,
      rooms,
    });
  };



  return (
    <div className="min-h-screen flex flex-col">
      {/* Hero Section with Video Background */}
      <div className="relative min-h-[85vh] flex items-center">
        {/* Video Background */}
        <div className="absolute inset-0 overflow-hidden">
          <video
            autoPlay
            loop
            muted
            playsInline
            className="absolute inset-0 w-full h-full object-cover"
          >
            <source src="/video-bg.mp4" type="video/mp4" />
          </video>

          {/* LIGHTER Overlay */}
          <div className="absolute inset-0 bg-gradient-to-br from-[#2B4979]/70 via-[#3d5c8f]/60 to-[#2B4979]/70"></div>

          {/* Subtle animated dots */}
          <div className="absolute inset-0 opacity-20">
            <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full filter blur-3xl animate-pulse"></div>
            {/* <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#FF7B47] rounded-full filter blur-3xl animate-pulse" style={{animationDelay: '1s'}}></div> */}
          </div>
        </div>

        {/* Content */}
        <div className="container mx-auto px-4 py-16 relative z-10">
          <div className="text-center text-white mb-12">
            <h1 className="text-5xl md:text-6xl font-bold mb-4 drop-shadow-2xl">
              Réservez les meilleurs hôtels en Tunisie
            </h1>
            <p className="text-xl md:text-2xl text-white drop-shadow-lg">
              Plateforme B2B - Tarifs exclusifs avec vos marges personnalisées
            </p>
          </div>

          {/* Search Box */}
          <div className="max-w-6xl mx-auto bg-white/95 backdrop-blur-sm rounded-2xl shadow-2xl p-6">
            <div className="flex items-center gap-3 mb-6 pb-4 border-b">
              <Hotel className="text-[#FF7B47]" size={32} />
              <h2 className="text-2xl font-bold text-[#2B4979]">
                Recherchez votre hôtel
              </h2>
            </div>

            {/* Inputs Grid */}
            <div className="flex flex-col md:flex-row gap-4 mb-4">
              {/* Destination */}
              <div className="flex-1">
                <label className="flex items-center gap-2 text-[#2B4979] font-semibold mb-2 text-sm">
                  <MapPin size={16} className="text-[#FF7B47]" />
                  Destination
                </label>
                <select
                  value={destination}
                  onChange={(e) => setDestination(e.target.value)}
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-[#FF7B47] focus:outline-none transition"
                >
                  <option value="">Choisir...</option>
                  {STATIC_CITIES.map((city) => (
                    <option key={city.Id} value={city.Id}>
                      {city.Name}
                    </option>
                  ))}
                </select>
              </div>

              {/* Date Range */}
              <div className="flex-1 relative" ref={calendarRef}>
                <label className="flex items-center gap-2 text-[#2B4979] font-semibold mb-2 text-sm">
                  <Calendar size={16} className="text-[#FF7B47]" />
                  Dates de séjour
                </label>
                <button
                  type="button"
                  onClick={() => setShowCalendar(!showCalendar)}
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg hover:border-[#FF7B47] transition text-left bg-white"
                >
                  <span className="text-gray-700">
                    {dateRange[0].startDate.toLocaleDateString("fr-FR")} -{" "}
                    {dateRange[0].endDate.toLocaleDateString("fr-FR")}
                  </span>
                </button>

                {showCalendar && (
                  <div className="absolute top-full left-0 mt-2 z-50 bg-white rounded-lg shadow-2xl border-2 border-gray-200">
                    <DateRange
                      ranges={dateRange}
                      onChange={(item) => setDateRange([item.selection])}
                      months={2}
                      direction="horizontal"
                      minDate={new Date()}
                      rangeColors={["#FF7B47"]}
                      locale={fr}
                    />
                    <div className="p-4 border-t">
                      <button
                        type="button"
                        onClick={() => setShowCalendar(false)}
                        className="w-full bg-[#2B4979] text-white py-2 rounded-lg hover:bg-[#1e3454] transition"
                      >
                        Confirmer
                      </button>
                    </div>
                  </div>
                )}
              </div>

              {/* Rooms */}
              <div className="flex-1">
                <label className="flex items-center gap-2 text-[#2B4979] font-semibold mb-2 text-sm">
                  <Users size={16} className="text-[#FF7B47]" />
                  Voyageurs
                </label>
                <RoomSelector rooms={rooms} setRooms={setRooms} />
              </div>
            </div>

            {/* BIG SEARCH BUTTON */}
            <div className="mt-6 flex justify-center">
              <button
                onClick={handleSearch}
                className="w-full md:w-1/2 lg:w-1/3 bg-[#FF7B47] hover:bg-[#ff6a30] text-white font-bold py-4 text-lg rounded-lg transition duration-200 transform hover:scale-[1.03] shadow-xl flex items-center justify-center gap-3"
              >
                <Search size={24} />
                RECHERCHER
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Features Section */}
      <div className="bg-gray-50 py-16">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-[#2B4979] text-center mb-12">
            Pourquoi choisir 216 Booking ?
          </h2>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white p-6 rounded-xl shadow-md text-center">
              <div className="bg-[#FF7B47] w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <Hotel size={32} className="text-white" />
              </div>
              <h3 className="font-bold text-xl text-[#2B4979] mb-3">
                Réservations Instantanées
              </h3>
              <p className="text-gray-600">
                Accès en temps réel aux disponibilités et confirmation immédiate
              </p>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-md text-center">
              <div className="bg-[#FF7B47] w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <MapPin size={32} className="text-white" />
              </div>
              <h3 className="font-bold text-xl text-[#2B4979] mb-3">
                Meilleurs Tarifs B2B
              </h3>
              <p className="text-gray-600">
                Tarifs exclusifs négociés avec vos marges personnalisées
              </p>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-md text-center">
              <div className="bg-[#FF7B47] w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <Users size={32} className="text-white" />
              </div>
              <h3 className="font-bold text-xl text-[#2B4979] mb-3">
                Support 24/7
              </h3>
              <p className="text-gray-600">
                Assistance dédiée pour vous accompagner à tout moment
              </p>
            </div>
          </div>
        </div>
      </div>

      <Footer brand={brand} />
    </div>
  );
}
